import CloudinaryImage from './CloudinaryImage';

export default CloudinaryImage;
